import React, { ReactNode } from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './empty-state.style';

export enum IconSizes {
  Default = 'default',
  Large = 'large',
}

export enum EmptyStateVariants {
  Section = 'section',
  Page = 'page',
}

export type EmptyStateProps = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  description?: ReactNode;
  iconSize?: IconSizes;
  variant?: EmptyStateVariants;
  children?: ReactNode;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  iconSize = IconSizes.Default,
  variant = EmptyStateVariants.Section,
  children,
}) => {
  const isPage = variant === EmptyStateVariants.Page;

  return (
    <Styled.Container $page={isPage}>
      <Styled.IconContainer
        $large={iconSize === IconSizes.Large}
        $page={isPage}
      >
        <Icon icon={icon} />
      </Styled.IconContainer>

      <Styled.Content>
        <Styled.Title $page={isPage}>{title}</Styled.Title>
        {!!description && (
          <Styled.Description>{description}</Styled.Description>
        )}
      </Styled.Content>

      {!!children && <Styled.Interactions>{children}</Styled.Interactions>}
    </Styled.Container>
  );
};
